const getAnalyticsProxy = () => (window.maxAnalyticsPublicEvents = window.maxAnalyticsPublicEvents || [])

export const pushAnalyticsPublicEvent = (eventName, brand) => {
  getAnalyticsProxy().push(
    new CustomEvent("maxAnalyticsEvent", {
      detail: {
        eventName: eventName,
        page: window.location.pathname,
        eventData: { "source": "WEB", "brand": brand }
      }
    })
  )
}
